"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalRepository = void 0;
const httpRepository_1 = __importDefault(require("./httpRepository"));
const requestRepository_1 = __importDefault(require("./requestRepository"));
exports.ApprovalRepository = {
    getApprovals: async (state) => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/approvals', {
            params: { state },
        });
        return response.data;
    },
    closeStuckPendingApproval: async (stuckPendingApprovalId) => {
        const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/requests/${stuckPendingApprovalId}/close`);
        return response.data;
    },
    declinePendingApproval: async ({ subjectId, taskId }) => {
        const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/requests/${subjectId}/reject`, {
            taskId,
        });
        return response.data;
    },
    getTeamApprovers: async (teamId, approverId) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/teams/${teamId}/approvers?excludeOutOfOffice=true`);
        const { users: approvers = [] } = response.data;
        const approverOptions = approvers
            ?.map(({ userId: id, fullName: label, email }) => ({ id, email, label }))
            .filter(({ id }) => id !== approverId);
        return approverOptions;
    },
    forwardRequest: async ({ assignee, approval, previousAssignee, reason }) => {
        const requestId = approval.subjectId;
        const taskId = approval.id;
        const assigneeId = assignee.id || assignee.userId;
        const getAssignee = await httpRepository_1.default.tradeshiftGo().get(`/rest/users/${assigneeId}`);
        const reassignRequest = await httpRepository_1.default.tradeshiftGo().post(`/rest/requests/${requestId}/reassign/${assigneeId}`, { previousAssignee, reason, taskId });
        return { assignee: getAssignee.data, reassignee: reassignRequest.data };
    },
    cancelApproval: async ({ subjectId, virtualCardId, taskId }) => {
        if (virtualCardId) {
            const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/tasks/${subjectId}/cards/${virtualCardId}`, {
                taskId,
            });
            return response.data;
        }
        else {
            const requestData = await requestRepository_1.default.getRequest({ requestId: subjectId });
            const response = await httpRepository_1.default.tradeshiftGo().post(`/rest/tasks/${subjectId}/cards/${requestData.virtualCardId}`, {
                taskId,
            });
            return response.data;
        }
    },
    approve: async (approvalRequest) => {
        return await httpRepository_1.default.tradeshiftGo().post(`/rest/requests/${approvalRequest.requestId}/approve`, approvalRequest);
    },
};
